module.exports = __webpack_public_path__ + "media/images/property-info-dd31b3cb.png";